import type { IBar3dSeriesTheme } from './interface';

export const bar3d: IBar3dSeriesTheme = {
  bar3d: {
    style: {
      length: 3
    }
  },
  label: {
    visible: false,
    style: {
      offset: 12,
      position: 'outside'
    }
  }
};
